import(/* webpackMode: "eager" */ "/var/www/academy-frontend/src/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/academy-frontend/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/common/layouts/MainLayout.js");
